var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomDarkGreenShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 164,
    viewBox: "0 0 374 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-83.0031 0H-24.4132C195.396 0 373.587 178.191 373.587 398H-83.0031V0Z",
    fill: "#488257"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomDarkGreenShape);
export default __webpack_public_path__ + "static/media/Bottom Dark Green Shape.6133d554331fa26d48c9fb637b2c3222.svg";
export { ForwardRef as ReactComponent };